import { RecommendationType } from '@/webapi/use-widget-catalog-api';
import { getStrategiesByType } from '@/utils/recommendation-strategies';

export const CHECKOUT_SUPPORTED_UPSELL_STRATEGIES = getStrategiesByType([
  RecommendationType.MANUAL,
  RecommendationType.VIEWD_TOGETHER,
  RecommendationType.PERSONALIZED,
  RecommendationType.PURCHASED_TOGETHER,
  RecommendationType.SIMILAR_PRODUCTS,
  RecommendationType.ADVANCED_RULING,
  RecommendationType.MOST_POPULAR,
  RecommendationType.NEW_ARRIVALS,
  RecommendationType.PAST_PURCHASES,
  RecommendationType.RECENTLY_VIEWED,
]);
